/**
 * Zoony product hero: option radios → variant id, availability, gallery.
 * #zoony-product-form, #zoony-product-variants-data; optional gallery via window.zoonyProductGalleryGoTo.
 */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function optionCount(variants) {
    return variants[0] && variants[0].options ? variants[0].options.length : 0;
  }

  /** For each option index, which string values appear on at least one variant (any stock). */
  function valueSetsByOptionIndex(variants) {
    var n = optionCount(variants);
    var sets = [];
    for (var i = 0; i < n; i++) sets[i] = Object.create(null);
    for (var v = 0; v < variants.length; v++) {
      var opts = variants[v].options;
      for (var i = 0; i < opts.length; i++) sets[i][opts[i]] = true;
    }
    return sets;
  }

  function getSelectionArray(form) {
    var maxPos = 0;
    form.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (!Number.isNaN(p) && p > maxPos) maxPos = p;
    });
    var sel = [];
    for (var i = 0; i < maxPos; i++) sel[i] = null;
    form.querySelectorAll('input[type="radio"][data-option-position]:checked').forEach(function (inp) {
      var p = parseInt(inp.getAttribute('data-option-position'), 10);
      if (Number.isNaN(p)) return;
      sel[p - 1] = inp.getAttribute('data-option-value');
    });
    return sel;
  }

  function variantMatchesSelectionWithOverride(v, selection, overrideIndex, overrideValue) {
    for (var i = 0; i < v.options.length; i++) {
      var want = i === overrideIndex ? overrideValue : selection[i];
      if (want != null && want !== '' && v.options[i] !== want) return false;
    }
    return true;
  }

  /** In-stock variant exists matching current selection except at overrideIndex = overrideValue. */
  function hasAvailableVariant(variants, selection, overrideIndex, overrideValue) {
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.available) continue;
      if (variantMatchesSelectionWithOverride(variant, selection, overrideIndex, overrideValue)) return true;
    }
    return false;
  }

  function findExactVariant(variants, sel) {
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (variant.options.length !== sel.length) continue;
      var ok = true;
      for (var i = 0; i < sel.length; i++) {
        if (variant.options[i] !== sel[i]) {
          ok = false;
          break;
        }
      }
      if (ok) return variant;
    }
    return null;
  }

  function updateAvailability(form, variants, valueSets) {
    var selection = getSelectionArray(form);
    var inputs = form.querySelectorAll('input[type="radio"][data-option-position]');
    inputs.forEach(function (inp) {
      var idx = parseInt(inp.getAttribute('data-option-position'), 10) - 1;
      var kind = inp.getAttribute('data-zoony-option-kind') || 'choice';
      var val = inp.getAttribute('data-option-value');
      var ok;
      if (kind === 'color') {
        ok = !!(valueSets[idx] && valueSets[idx][val]);
      } else {
        ok = hasAvailableVariant(variants, selection, idx, val);
      }
      inp.disabled = !ok;
      inp.setAttribute('aria-disabled', ok ? 'false' : 'true');
      var lab = form.querySelector('label[for="' + inp.id + '"]');
      if (lab) lab.classList.toggle('zoony-option-label--unavailable', !ok);
    });
  }

  function parseGalleryUrls() {
    var gel = document.getElementById('zoony-product-gallery-data');
    if (!gel) return [];
    try {
      var u = JSON.parse(gel.textContent.trim());
      return Array.isArray(u) ? u : [];
    } catch (e) {
      return [];
    }
  }

  function getSelectedColorValue(form, sel) {
    var checked = form.querySelector('input[type="radio"][data-zoony-option-kind="color"]:checked');
    if (checked) return checked.getAttribute('data-option-value');
    if (!Array.isArray(sel)) return null;
    var colorInput = form.querySelector('input[type="radio"][data-zoony-option-kind="color"][data-option-position]');
    if (!colorInput) return null;
    var pos = parseInt(colorInput.getAttribute('data-option-position'), 10) - 1;
    if (Number.isNaN(pos) || pos < 0 || pos >= sel.length) return null;
    return sel[pos];
  }

  function urlMatchesSelectedColor(url, colorValue) {
    if (!url || !colorValue) return false;
    if (!window.zoonyColorImageMatch || typeof window.zoonyColorImageMatch.urlMatchesColor !== 'function') return false;
    return window.zoonyColorImageMatch.urlMatchesColor(url, colorValue);
  }

  function urlMatchesGeneral(url) {
    if (!url) return false;
    if (!window.zoonyColorImageMatch || typeof window.zoonyColorImageMatch.urlMatchesGeneral !== 'function') return false;
    return window.zoonyColorImageMatch.urlMatchesGeneral(url);
  }

  function galleryUrlStem(u) {
    if (!u) return '';
    var s = String(u).split('?')[0];
    var m = s.match(/\/([^/?]+)$/);
    return m ? m[1] : s;
  }

  /** Match variant featured_image URL to a gallery slide index (width/query may differ). */
  function galleryIndexForFeatured(featuredUrl, galleryUrls) {
    if (!featuredUrl || !galleryUrls.length) return -1;
    var a = String(featuredUrl).split('?')[0];
    var stemA = galleryUrlStem(a);
    for (var i = 0; i < galleryUrls.length; i++) {
      var b = String(galleryUrls[i]).split('?')[0];
      if (a === b) return i;
      var stemB = galleryUrlStem(b);
      if (
        stemA &&
        stemB &&
        stemA.length >= 6 &&
        stemB.length >= 6 &&
        (stemA === stemB || stemA.indexOf(stemB) !== -1 || stemB.indexOf(stemA) !== -1)
      )
        return i;
    }
    return -1;
  }

  function urlShotIndex(url) {
    if (!window.zoonyColorImageMatch || typeof window.zoonyColorImageMatch.urlShotIndex !== 'function') return null;
    return window.zoonyColorImageMatch.urlShotIndex(url);
  }

  /** Prefer filename shot 1 (black_1_…) over Shopify upload order / variant featured image. */
  function galleryIndexForShot(galleryUrls, colorVal, wantShot) {
    if (!galleryUrls.length) return -1;
    var fallback = -1;
    var fallbackShot = 9999;
    for (var i = 0; i < galleryUrls.length; i++) {
      if (colorVal && !urlMatchesSelectedColor(galleryUrls[i], colorVal)) continue;
      var shot = urlShotIndex(galleryUrls[i]);
      if (shot === wantShot) return i;
      if (typeof shot === 'number' && !Number.isNaN(shot) && shot < fallbackShot) {
        fallbackShot = shot;
        fallback = i;
      } else if (fallback < 0) {
        fallback = i;
      }
    }
    return fallback;
  }

  /** If this variant has no image, use first variant with same color that does (common Shopify setup). */
  function galleryIndexForColorFallback(form, variants, sel, galleryUrls) {
    if (!galleryUrls.length) return -1;
    var colorVal = getSelectedColorValue(form, sel);
    var byShot = galleryIndexForShot(galleryUrls, colorVal, 1);
    if (byShot >= 0) return byShot;
    if (!colorVal) return -1;
    var checked = form.querySelector('input[type="radio"][data-zoony-option-kind="color"]:checked');
    var cIdx = checked ? parseInt(checked.getAttribute('data-option-position'), 10) - 1 : -1;
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (cIdx >= 0 && variant.options && variant.options[cIdx] !== colorVal) continue;
      if (typeof variant.image_index === 'number' && !Number.isNaN(variant.image_index)) return variant.image_index;
      if (variant.featured_image) {
        var gi = galleryIndexForFeatured(variant.featured_image, galleryUrls);
        if (gi >= 0) return gi;
      }
    }
    for (var i = 0; i < galleryUrls.length; i++) {
      if (urlMatchesSelectedColor(galleryUrls[i], colorVal)) return i;
    }
    return -1;
  }

  function isGalleryIndexColorMatch(idx, galleryUrls, colorVal) {
    if (!colorVal) return true;
    if (idx < 0 || idx >= galleryUrls.length) return false;
    if (urlMatchesSelectedColor(galleryUrls[idx], colorVal)) return true;
    // Shared general_1 / general_1_{product-key} shots are allowed for every color.
    if (urlMatchesGeneral(galleryUrls[idx])) return true;
    return false;
  }

  function goToGalleryIndex(originalIndex) {
    if (typeof window.zoonyProductGalleryGoTo !== 'function') return;
    var filtered = originalIndex;
    if (typeof window.zoonyColorGalleryToFilteredIndex === 'function') {
      var mapped = window.zoonyColorGalleryToFilteredIndex(originalIndex);
      if (mapped >= 0) {
        filtered = mapped;
      } else if (typeof window.zoonyColorGalleryGetVisibleIndices === 'function') {
        var visible = window.zoonyColorGalleryGetVisibleIndices();
        if (visible && visible.length) filtered = 0;
      }
    }
    window.zoonyProductGalleryGoTo(filtered);
  }

  function ensureValidSelection(form) {
    var groups = {};
    form.querySelectorAll('input[type="radio"][data-option-position]').forEach(function (inp) {
      var p = inp.getAttribute('data-option-position');
      if (!groups[p]) groups[p] = [];
      groups[p].push(inp);
    });
    Object.keys(groups).forEach(function (posKey) {
      var list = groups[posKey];
      var checked = list.filter(function (i) {
        return i.checked;
      })[0];
      if (checked && !checked.disabled) return;
      var first = list.find(function (i) {
        return !i.disabled;
      });
      if (!first) {
        if (checked) checked.checked = false;
        return;
      }
      list.forEach(function (i) {
        i.checked = false;
      });
      first.checked = true;
    });
  }

  function updateProductPrice(variant) {
    var currentEl = document.querySelector('[data-zoony-price-current]');
    var compareEl = document.querySelector('[data-zoony-price-compare]');
    if (!variant) return;

    if (currentEl) {
      currentEl.textContent =
        variant.price_formatted ||
        (typeof variant.price === 'number'
          ? 'EGP ' + (variant.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : currentEl.textContent);
    }

    if (compareEl) {
      var showCompare =
        variant.compare_at_price != null &&
        variant.price != null &&
        Number(variant.compare_at_price) > Number(variant.price);
      if (showCompare) {
        compareEl.textContent =
          variant.compare_at_price_formatted ||
          'EGP ' +
            (Number(variant.compare_at_price) / 100).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.setAttribute('hidden', '');
      }
    }

    try {
      document.dispatchEvent(
        new CustomEvent('variant:change', { detail: { variant: variant } })
      );
    } catch (e) {}
  }

  function applyVariant(form, variant, galleryUrls, variants) {
    var idInput = form.querySelector('[data-zoony-variant-id-input]');
    if (!idInput || !variant) return;
    idInput.value = String(variant.id);

    // Always refresh PDP price on every option click / variant match
    updateProductPrice(variant);

    var sel = getSelectionArray(form);
    var colorVal = getSelectedColorValue(form, sel);
    var idx = galleryIndexForShot(galleryUrls, colorVal, 1);
    if (idx >= 0 && !isGalleryIndexColorMatch(idx, galleryUrls, colorVal)) {
      idx = -1;
    }
    if (idx < 0) {
      idx = galleryIndexForColorFallback(form, variants, sel, galleryUrls);
    }

    if (idx >= 0) {
      goToGalleryIndex(idx);
      return;
    }

    var mainImg = document.getElementById('mainImg');
    var imgSrc = variant.featured_image;
    if (!imgSrc) {
      var altIdx = galleryIndexForColorFallback(form, variants, sel, galleryUrls);
      if (altIdx >= 0 && galleryUrls[altIdx]) imgSrc = galleryUrls[altIdx];
    }
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
      mainImg.removeAttribute('srcset');
    }
  }

  function syncFromForm(form, variants, valueSets, galleryUrls) {
    updateAvailability(form, variants, valueSets);
    ensureValidSelection(form);
    var sel = getSelectionArray(form);
    var complete = sel.every(function (x) {
      return x != null && x !== '';
    });
    if (!complete) return;
    var variant = findExactVariant(variants, sel);
    if (variant) applyVariant(form, variant, galleryUrls, variants);
  }

  onReady(function () {
    var form = document.getElementById('zoony-product-form');
    var dataEl = document.getElementById('zoony-product-variants-data');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent.trim());
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    var valueSets = valueSetsByOptionIndex(variants);
    var galleryUrls = parseGalleryUrls();

    form.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('input[type="radio"][data-option-position]')) return;
      syncFromForm(form, variants, valueSets, galleryUrls);
    });

    syncFromForm(form, variants, valueSets, galleryUrls);
  });
})();
